/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CheckInType,
  CheckInTypeOptional,
  CheckInTypeMetaI,
  CheckInTypeTrackedI,
} from "./check-in-type";
import { CheckInTypeTracked, CheckInTypeMeta } from "./check-in-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";

/**
 *
 * @export
 * @interface CreatePersonCheckInDTO
 */
export interface CreatePersonCheckInDTOOptional {
  /**
   *
   * @type {string}
   * @memberof CreatePersonCheckInDTO
   */
  cardNum?: string;
  /**
   *
   * @type {PersonRef}
   * @memberof CreatePersonCheckInDTO
   */
  personId?: PersonRefOptional;
  /**
   *
   * @type {CheckInType}
   * @memberof CreatePersonCheckInDTO
   */
  checkInType?: CheckInType;
}

export interface CreatePersonCheckInDTO extends CreatePersonCheckInDTOOptional {
  /**
   *
   * @type {string}
   * @memberof CreatePersonCheckInDTO
   */
  cardNum?: string;
  /**
   *
   * @type {PersonRef}
   * @memberof CreatePersonCheckInDTO
   */
  personId?: PersonRef;
  /**
   *
   * @type {CheckInType}
   * @memberof CreatePersonCheckInDTO
   */
  checkInType: CheckInType;
}

export interface CreatePersonCheckInDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof CreatePersonCheckInDTO
   */
  cardNum?: string;
  cardNumIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof CreatePersonCheckInDTO
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {CheckInType}
   * @memberof CreatePersonCheckInDTO
   */
  checkInType?: CheckInType;
  checkInTypeIsSet: boolean;
}

transformDatesMap.set(
  "CreatePersonCheckInDTO",
  function (model: CreatePersonCheckInDTO) {
    const transformDatespersonId = transformDatesMap.get("PersonRef");
    if (transformDatespersonId && model.personId) {
      transformDatespersonId(model.personId);
    }
  },
);

export type CreatePersonCheckInDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  cardNum: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  checkInType: PropertyMeta<CheckInTypeMetaI>;
}>;

export var CreatePersonCheckInDTOMeta: CreatePersonCheckInDTOMetaI =
  {} as CreatePersonCheckInDTOMetaI;
CreatePersonCheckInDTOMeta = typeMeta("CreatePersonCheckInDTO", {
  cardNum: propertyMeta("cardNum", false, false, false, MetaTypesBase.string),
  personId: propertyMeta("personId", false, false, false, PersonRefMeta),
  checkInType: propertyMeta("checkInType", false, true, false, CheckInTypeMeta),
});

const metaI = CreatePersonCheckInDTOMeta;

registerMeta(() => {});

export class CreatePersonCheckInDTOTracked implements CreatePersonCheckInDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  cardNum__I?: string = undefined;
  cardNumIsSet: boolean = false;
  set cardNum(v: undefined | string) {
    if (v !== undefined) {
      this.cardNum__I = v;
      this.cardNumIsSet = true;
    } else {
      this.cardNum__I = v || undefined;
      this.cardNumIsSet = false;
    }
    this.changeTracker = true;
  }
  get cardNum() {
    return this.cardNum__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  checkInType__I?: CheckInType = undefined;
  checkInTypeIsSet: boolean = false;
  set checkInType(v: undefined | CheckInType) {
    if (v !== undefined) {
      this.checkInType__I = v;
      this.checkInTypeIsSet = true;
    } else {
      this.checkInType__I = v || undefined;
      this.checkInTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get checkInType() {
    return this.checkInType__I;
  }
  constructor(
    config?: CreatePersonCheckInDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.personId?.setIds();
  }
  assignFrom(
    config: CreatePersonCheckInDTOOptional,
    options?: AssignOptions,
  ): CreatePersonCheckInDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.cardNum && this.cardNumApplyFilter(optionsRequired.filter)) {
      this.cardNum = config.cardNum;
      if (optionsRequired.unassign) this.cardNumIsSet = false;
      else this.cardNumIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (
      config.checkInType &&
      this.checkInTypeApplyFilter(optionsRequired.filter)
    ) {
      this.checkInType = config.checkInType;
      if (optionsRequired.unassign) this.checkInTypeIsSet = false;
      else this.checkInTypeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CreatePersonCheckInDTOTrackedI {
    const cloned = {} as CreatePersonCheckInDTOTrackedI;
    if (
      this.cardNumIsSetDeep() &&
      this.cardNumApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cardNumIsSet = true;
      cloned.cardNum = this.cardNum;
    } else {
      //cloned.cardNumIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.checkInTypeIsSetDeep() &&
      this.checkInTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.checkInTypeIsSet = true;
      cloned.checkInType = this.checkInType;
    } else {
      //cloned.checkInTypeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CreatePersonCheckInDTOTrackedI {
    if (!this.cardNumApplyFilter(filter)) this.cardNumIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.checkInTypeApplyFilter(filter)) this.checkInTypeIsSet = false;

    return this;
  }
  cardNumApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreatePersonCheckInDTOMeta.cardNum,
      CreatePersonCheckInDTOMeta,
      this.cardNum,
      this,
    );
  }
  cardNumIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cardNumIsSet && this.cardNumApplyFilter(filter)) return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreatePersonCheckInDTOMeta.personId,
      CreatePersonCheckInDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  checkInTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreatePersonCheckInDTOMeta.checkInType,
      CreatePersonCheckInDTOMeta,
      this.checkInType,
      this,
    );
  }
  checkInTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.checkInTypeIsSet && this.checkInTypeApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.cardNumIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.checkInTypeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
